export function renderSelect({
	label,
	labelSuffix = ':',
	labelPlacement = 'inside',
	options,
	selectId,
	inputClass = '',
	multiple = false,
}: {
	label: string
	labelSuffix?: string
	labelPlacement?: 'inside' | 'outside'
	options?: string
	selectId: string
	inputClass?: string
	multiple?: boolean
}): string {
	const labelPlacementClass =
		labelPlacement === 'outside' ? 'label-outside' : ''
	const labelMarkup = `<label for="${selectId}" class="f secondary">${label}${labelSuffix}</label>`
	const multipleAttr = multiple ? ' multiple' : ''
	return `
        <div class="tt-select ${labelPlacementClass}">
            ${labelPlacement === 'outside' ? labelMarkup : ''}
            <select id="${selectId}" name="${selectId}" class="select-auto-width ${inputClass}"${multipleAttr}>
                ${options}
            </select>
            <svg><use href="#symbols-arrow-down"></use></svg>
            ${labelPlacement === 'inside' ? labelMarkup : ''}
        </div>
    `
}
